import React from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'
import PublicationBadge from '../../GeneralComponents/PublicationBadge'
import ExplicitTag from '../../GeneralComponents/ExplicitTag'
export default function ArtistTopTeaseGridItem({ song, onClick }) {
  const date = new Date(song.date_published)

  const formattedDate = song.date_published
    ? date.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
      })
    : null

  return (
    <div className={classes.wrapper} onClick={() => onClick(song)}>
      {!song.is_published ? <div className={classes.layout}></div> : null}
      <div
        className={`${classes.itemWrapper} ${
          !song.is_published ? classes.itemWrapper__unpublished : ''
        }`.trim()}
      >
        <div className={classes.imageWrapper}>
          <img
            src={song?.image?.url}
            alt="sound image"
            className={classes.image}
          />
        </div>
        <div className={classes.textWrapper}>
          <div className={classes.songNameWrapper}>
            <p
              className={`${classes.itemTitle} ${
                song?.is_explicit ? classes.shortenTitle : ''
              }`}
            >
              {song?.name}
            </p>
            {song?.is_explicit && <ExplicitTag size="small" />}
          </div>
          {formattedDate ? (
            <p className={classes.itemSubtitle}>Launched: {formattedDate}</p>
          ) : null}
          <p className={classes.itemMessageCount}>{`${
            song?.feels_count
          } Feels`}</p>
          {song?.is_promotional ? (
            <div className={classes.badge}>
              <PublicationBadge
                size="sm"
                status={'published'}
                text={song.is_published ? 'Published' : 'Unpublished'}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

ArtistTopTeaseGridItem.propTypes = {
  song: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}
